import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../lib/analytics';

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when route changes
    trackPageView(location.pathname);
  }, [location]);

  return null; // This component doesn't render anything
};

export default GoogleAnalytics;
